import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import images from './images/images';
import {isMobile} from 'react-device-detect';

const InvoiceEmptyItemComponent = (props) => {
  const cssClasses = ['invoice-box', 'text-center', 'empty'];
  const {isNewCustomer, billCycle, error, previous, isMobile} = props;
  props.error ? cssClasses.push('invoice-error') : cssClasses.push('new-customer');

  return (
    <Container className={cssClasses.join(' ').trim()} fluid={true}>
      {error ? (
        <div className='error-style'>
          <Row>
            <Col xs={12}>
              <div className='error-text'>
                <span className='image-error'>
                  <Image alt='error' src={images.error} />
                  <span>&ensp;</span>
                </span>
                <span className='error-text-black'>מצטערים, משהו השתבש והחשבונית לא נטענה</span>
               
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        <div className='new-customer-container'>
          <div className='new-customer-image'>
            <Image src={images.newcustomer} alt='new customer image' />
          </div>
          <div className='new-customer-welcome-text'>
            <span className='welcome-text-design'> ברוכים הבאים ל{window.Config.brand_Name_HE} </span>
          <div className='new-customer-invoice-info'>
            <span> החשבונית הראשונה שלך תופיע כאן החל מ-</span>
            <span>{billCycle}</span>
          </div>
        </div>
        </div>
      )}
    </Container>
  );
};

export default InvoiceEmptyItemComponent;
